import type { ReactNode } from "react";
import { social_link_motion, text_motion } from "./_config";
import { motion } from "framer-motion";
import type { BucketIcon, IconColor } from "~/types/icon";
import Link from "next/link";
import Icon from "~/components/icons";

interface ContactBarProps {
  children: Readonly<ReactNode>;
  title: string;
}

export default function ContactBar({ title, children }: ContactBarProps) {
  return (
    <motion.div
      variants={text_motion}
      initial="hidden"
      whileInView="visible"
      transition={{ delay: 0.5, duration: 0.9 }}
      className="flex flex-col gap-5"
    >
      <div className="flex items-center gap-1 xl:gap-2">
        <span className="font-bolder text-lg text-white">{title}</span>
        <hr className="bg-opacity-30 h-px grow border-0 bg-[#1b1b1b]" />
      </div>
      <ul className="flex flex-wrap items-center justify-between gap-4 px-2 sm:px-10">
        {children}
      </ul>
    </motion.div>
  );
}

interface ContactBarItemProps {
  index: number;
  icon: BucketIcon;
  label: string;
  link: string;
  color: IconColor;
}

export const ContactBarItem = ({ icon, color, label, link, index }: ContactBarItemProps) => {
  return (
    <motion.li
      variants={social_link_motion}
      initial="hidden"
      whileInView="visible"
      transition={{
        delay: 0.6 + index * 0.1,
        type: "spring",
        stiffness: 100,
      }}
      className="flex flex-col items-center gap-1"
    >
      <Link href={link} target="_blank" rel="noopener noreferrer">
        <Icon icon={icon} color={color}  />
        <span className="text-white xl:text-base xl:leading-6 xl:font-medium">
          {label}
        </span>
      </Link>
    </motion.li>
  );
}
